export default __webpack_public_path__ + "static/media/estatuamiguel.d3f13382.jpg";